// Components
if(document.querySelector('.js-slideshow-stage')) {
	import(/* webpackChunkName: "slideshow" */ './components/slideshow');
}

import './components/cookieconsent';
import './components/header';

// Vendor
import 'lazysizes';



// WEBPACK FOOTER //
// ./assets/src/js/script.js